<template>
  <v-container class="fill-height ma-0 pa-0" fluid>
    <background-image :src="background" :fitToHeight="true">
      <slot></slot>
    </background-image>
    <slot name="extra"></slot>
  </v-container>
</template>

<script>
import { useUserStore } from "@/store/user";
import { attemptAdminToolRedirect } from "@/utils/adminTools";

export default {
  name: "PublicPage",
  props: {
    background: {
      type: String,
      default: () => process.env.VUE_APP_DEFAULT_BACKGROUND || "ngc2244.jpg",
    },
    // Opt out of the "already logged in -> bounce to Profile" redirect below.
    // Needed by pages whose whole job is to act on a token from an email
    // link (ActivateAccount) regardless of whatever unrelated session
    // already happens to be active in the same browser - e.g. an admin
    // clicking a user's activation link while signed in themselves. Without
    // this, PublicPage's own mounted() (it's the child here, mounts before
    // the page component that renders it) redirects away before the page's
    // own mounted() - where the actual verify-token API call lives - ever
    // gets to run, so the call is silently never made at all. Confirmed via
    // production logs 2026-08-26: GET /api/v1/accounts/verify/<token>/ never
    // reached the backend even once for an activation link opened by an
    // already-authenticated admin.
    skipAuthRedirect: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BackgroundImage: () => import("@/components/BackgroundImage"),
  },
  setup() {
    const userStore = useUserStore();
    return { userStore };
  },
  mounted() {
    // Change favicon
    // window.document.head
    //   .querySelectorAll("link[rel*='icon']")
    //   .forEach((el) => (el.href = `/favicon.ico`));
    if (this.skipAuthRedirect) {
      return;
    }
    if (this.userStore.isLoggedIn()) {
      // Already logged in and specifically trying to reach an admin tool
      // (bounced here by Traefik's forwardAuth check) — the JWT already
      // implies OTP was verified when it was issued, so skip straight to
      // minting that tool's session instead of forcing a redundant re-login.
      const next = this.$route.query.next;
      const handled = attemptAdminToolRedirect(next, (error) => {
        console.warn(error);
        this.$router.push({ name: "Profile" }, () => {});
      });
      if (handled) {
        return;
      }
      this.$router.push({ name: "Profile" }, () => {});
    }
  },
};
</script>
    
